import * as React from "react"
import { Switch as SwitchPrimitive } from "radix-ui"

import { cn } from "@/shadcn/lib/utils"

function Switch({
  className,
  size = "default",
  ...props
}: React.ComponentProps<typeof SwitchPrimitive.Root> & {
  size?: "sm" | "default"
}) {
  return (
    <SwitchPrimitive.Root
      data-slot="switch"
      data-size={size}
      className={cn(
        "peer group/switch relative inline-flex shrink-0 items-center rounded-full border border-transparent transition-colors duration-200 ease-out outline-none after:absolute after:-inset-x-3 after:-inset-y-2 focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 data-[size=default]:h-3 data-[size=default]:w-8 data-[size=sm]:h-2 data-[size=sm]:w-5.5 motion-reduce:transition-none dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40 data-checked:bg-primary/40 data-unchecked:bg-input dark:data-unchecked:bg-input/80 data-disabled:cursor-not-allowed data-disabled:opacity-50",
        className
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb
        data-slot="switch-thumb"
        className="pointer-events-none absolute top-1/2 block -translate-y-1/2 rounded-full bg-background shadow-sm ring-0 transition-all duration-200 ease-out group-data-[size=default]/switch:size-4.5 group-data-[size=sm]/switch:size-3.5 motion-reduce:transition-none group-data-[size=default]/switch:data-checked:translate-x-3.5 group-data-[size=default]/switch:data-checked:bg-primary group-data-[size=sm]/switch:data-checked:translate-x-2.25 group-data-[size=sm]/switch:data-checked:bg-primary group-data-[size=default]/switch:data-unchecked:-translate-x-px group-data-[size=sm]/switch:data-unchecked:-translate-x-px dark:data-unchecked:bg-foreground"
      />
    </SwitchPrimitive.Root>
  )
}

export { Switch }
